import React from 'react'

export default function PageCover(props) {
  return (
    <div className='PageCover'>
      <h2 className="">{props.title}</h2>
    </div>
  )
}
